export const getWeekDays = (day) => {
  const days = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"] 
  return days[day]
}

export const getWeekFullDays = (day) => {
  const days = ["domingo", "segunda", "terça", "quarta", "quinta", "sexta", "sábado"] 
  return days[day]
}